import { render, staticRenderFns } from "./ContentUpload.vue?vue&type=template&id=581bfd1f"
import script from "../../services/upload/contentupload.js?vue&type=script&lang=js&external"
export * from "../../services/upload/contentupload.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/upload/video-upload.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../../assets/css/upload/reset.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports